import { inject, Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { AlertController, AlertOptions, LoadingController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

/**
 * This service holds the functionality for alerts and loading dialogs
 * until they when they have a meaningful web-counterpart.
 * Then they might be added back in ./message.service.ts.
 */

@Injectable({
  providedIn: 'root',
})
export class IonicControllerService {
  private readonly alertController = inject(AlertController);
  private readonly loadingController = inject(LoadingController);
  private readonly translateService = inject(TranslateService);

  public async presentLoader(message?: string): Promise<void> {
    const loading = await this.loadingController.create({
      message: message ?? this.translateService.instant(_('general.text.loading')),
    });
    await loading.present();
  }

  public async dismissLoader(): Promise<void> {
    const loading = await this.loadingController.getTop();
    if (loading) {
      await loading.dismiss();
    }
  }

  public async showAlert(alertOptions: AlertOptions): Promise<void> {
    const alert = await this.alertController.create(alertOptions);
    await alert.present();
  }
}
